import React from 'react';
import { Global } from '@emotion/react';
import { rem, em } from './utils/rem/rem.js';

function assignSizeVariables(variables, sizes, name) {
  var targetUnitConverter = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : rem;
  Object.keys(sizes).forEach(function (size) {
    variables["--mantine-".concat(name, "-").concat(size)] = targetUnitConverter(sizes[size]);
  });
}

function MantineCssVariables(_ref) {
  var theme = _ref.theme;
  var variables = {
    "--mantine-color-white": theme.white,
    "--mantine-color-black": theme.black,
    "--mantine-transition-timing-function": theme.transitionTimingFunction,
    "--mantine-line-height": "".concat(theme.lineHeight),
    "--mantine-font-family": theme.fontFamily,
    "--mantine-font-family-monospace": theme.fontFamilyMonospace,
    "--mantine-font-family-headings": theme.headings.fontFamily,
    "--mantine-heading-font-weight": "".concat(theme.headings.fontWeight)
  };
  assignSizeVariables(variables, theme.shadows, "shadow");
  assignSizeVariables(variables, theme.fontSizes, "font-size");
  assignSizeVariables(variables, theme.radius, "radius");
  assignSizeVariables(variables, theme.spacing, "spacing");
  assignSizeVariables(variables, theme.breakpoints, "breakpoints", em);
  Object.keys(theme.colors).forEach(function (color) {
    theme.colors[color].forEach(function (shade, index) {
      variables["--mantine-color-".concat(color, "-").concat(index)] = shade;
    });
  });
  var headings = theme.headings.sizes;
  Object.keys(headings).forEach(function (heading) {
    variables["--mantine-".concat(heading, "-font-size")] = headings[heading].fontSize;
    variables["--mantine-".concat(heading, "-line-height")] = "".concat(headings[heading].lineHeight);
  });
  return (
    /* @__PURE__ */
    React.createElement(Global, {
      styles: {
        ":root": variables
      }
    })
  );
}

export { MantineCssVariables };